import React, { useLayoutEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  useLocation,
  RouteObject,
  Outlet,
} from "react-router-dom";
import { shouldRefreshOnNavigation } from "utils/clientVersionTracker";

export function Router({ routes }: { routes: RouteObject[] }) {
  const refreshWrappedRoutes = [
    {
      path: "/",
      element: <RefreshOnNavigationChecker />,
      children: routes,
    },
  ];

  const router = createBrowserRouter(refreshWrappedRoutes);

  return <RouterProvider router={router} />;
}

function RefreshOnNavigationChecker() {
  const location = useLocation();

  useLayoutEffect(() => {
    if (shouldRefreshOnNavigation()) {
      window.location.reload();
    }
  }, [location]);

  return <Outlet />;
}
